/**
 * Mappers para convertir entre DTOs y modelos de dominio de Product
 */

import { ProductOptionDto } from '@infra/dto/product.dto';
import { ProductOption } from '@domain/models/product.model';

export class ProductMapper {
  /**
   * Convierte un DTO ProductOptionDto a modelo de dominio
   */
  static toDomain(dto: ProductOptionDto): ProductOption {
    return {
      value: dto.value || '',
      label: dto.label || '',
      imgUrl: dto.imgUrl || '',
      category: dto.category || '',
      brand: dto.brand || '',
      measurementUnit: dto.measurementUnit || '',
      categoryOrder: dto.categoryOrder || 1,
      usageType: dto.usageType || '',
      application: dto.application || '',
      mainUses: dto.mainUses || '',
      advantages: dto.advantages || '',
    };
  }

  /**
   * Convierte una lista de DTOs a modelos de dominio
   */
  static toDomainList(dtos: ProductOptionDto[]): ProductOption[] {
    return dtos.map(dto => ProductMapper.toDomain(dto));
  }

  /**
   * Convierte un modelo de dominio ProductOption a DTO
   */
  static toDto(item: ProductOption): ProductOptionDto {
    return {
      value: item.value,
      label: item.label,
      imgUrl: item.imgUrl,
      category: item.category,
      brand: item.brand,
      measurementUnit: item.measurementUnit,
      categoryOrder: item.categoryOrder,
      usageType: item.usageType,
      application: item.application,
    };
  }
}

